import { GOOGLE_DRIVE_ROOT } from "./Gallery_URL";

export const PUBLIC_ROOT = process.env.PUBLIC_URL + "/public/";
export const PUBLICATION_FIG_ROOT = process.env.PUBLIC_URL + "/gallery/Publications/";

export const PORTRAIT1_URL = PUBLIC_ROOT + "Portrait_220102.jpg";
export const PORTRAIT2_URL = PUBLIC_ROOT + "Portrait_260307.jpg";
export const PORTRAIT2_SMALL_URL = PUBLIC_ROOT + "Portrait_260307_Gemini_64x64.png";

export const ARXIV_ICON_URL = PUBLICATION_FIG_ROOT + 'arxiv.svg';
export const YOUTUBE_ICON_URL = PUBLICATION_FIG_ROOT + 'youtube.svg';
export const GITHUB_ICON_URL = PUBLICATION_FIG_ROOT + 'github.svg';
export const EXTERNAL_ICON_URL = PUBLICATION_FIG_ROOT + 'external-link.svg';

export const PUB1_FIG_URL = PUBLICATION_FIG_ROOT + 'Pub1_JEAHT_2020.png';

export const PUB2_FIG_URL = PUBLICATION_FIG_ROOT + 'Pub2_IROS_2024.png';
export const PUB2_FRAMEWORK_URL = PUBLICATION_FIG_ROOT + 'Pub2_IROS_Fig2.png';
export const PUB2_RES1_URL = PUBLICATION_FIG_ROOT + 'Pub2_IROS_Fig3.png';
export const PUB2_RES2_URL = PUBLICATION_FIG_ROOT + 'Pub2_IROS_Fig4.png';

export const PUB2_POSTER_URL = 'https://drive.google.com/file/d/1_Mkyuzubq4hn7sdDfXC42fSxToC0XxMY/view?usp=sharing';
export const PUB2_SLIDES_URL = 'https://drive.google.com/file/d/1sVVFzy4G-XSVSVRVZ5DvLYapo3HAbj3s/view?usp=sharing';

export const PUB2_OUR_WINTER_VAR = GOOGLE_DRIVE_ROOT('1ogjVm_Qtu_xrVAwy7QELS6U8Vm7H4ufc'); 
export const PUB2_OUR_WINTER_SEM = GOOGLE_DRIVE_ROOT('1hUVxJ9a1KCC2jwt5oBhJWxVott7sh2em');
export const PUB2_SEE_WINTER_VAR = GOOGLE_DRIVE_ROOT('1-0oiqe4ThqBIa6CKzFGofDPczK3IGL2M');
export const PUB2_SEE_WINTER_SEM = GOOGLE_DRIVE_ROOT('1MzIMM_Guny1WBDMDaBmkLjB2zB15lQat');
export const PUB2_CON_WINTER_VAR = GOOGLE_DRIVE_ROOT('1sri83nSz7vuSMvBIqsYXKpuudzzrjleO');
export const PUB2_CON_WINTER_SEM = GOOGLE_DRIVE_ROOT('1zRbYyZu5WJZsPHE6b8KNL2TURPite_7y');
export const PUB2_BKI_WINTER_VAR = GOOGLE_DRIVE_ROOT('1iJthN64QpJS51kLr0uwrre5PlnD8keEZ');
export const PUB2_BKI_WINTER_SEM = GOOGLE_DRIVE_ROOT('1QTB_qeQ6y1oA8LUvUk1YPgnKAcyggm8y');

export const PUB2_SEM_VAR_OBJ = {
    'BKI' : [PUB2_BKI_WINTER_SEM, PUB2_BKI_WINTER_VAR],
    'CON': [PUB2_CON_WINTER_SEM, PUB2_CON_WINTER_VAR],
    'SEE': [PUB2_SEE_WINTER_SEM, PUB2_SEE_WINTER_VAR],
    'OUR': [PUB2_OUR_WINTER_SEM, PUB2_OUR_WINTER_VAR],
};

export const PUB3_FRAMEWORK_URL = GOOGLE_DRIVE_ROOT('1tuzBvZXWu9ESZYKDka8pFlg8CZY3KsTp');
export const PUB3_RES1_URL = GOOGLE_DRIVE_ROOT('1OFNflfdfPVYdxr8huAd9l0OciuddlMwZ');
export const PUB3_RES2_URL = GOOGLE_DRIVE_ROOT('1a4FiPVcDvLzMRN2YKxAl5cMtOKVLbgEQ');
export const PUB3_REPRESENTATIVE_PIC_V2_URL = GOOGLE_DRIVE_ROOT('1Ch2kHqmnC4pcarJVP44ISY5pPeDANIv9');
export const PUB3_POSTER_URL = 'https://drive.google.com/file/d/1KdAM25YnTGhKr-m4YkGuCrDUvKtx7fSl/view?usp=sharing';
export const PUB3_SLIDES_URL = 'https://drive.google.com/file/d/1XXcqQjxMFZbM9lo2cWx2VKSc3yGuk4XI/view?usp=sharing';


export const PUB4_REPRESENTATIVE_PIC_URL = GOOGLE_DRIVE_ROOT('1R8AcG_zD1vwkkZ6KObja9jsh6IFFAdtA');
export const PUB4_FRAMEWORK_URL = GOOGLE_DRIVE_ROOT('1UGepY6UwcmACcG4QfPav0R22wcIJGicG');
export const PUB4_CHALLENGES_URL = GOOGLE_DRIVE_ROOT('1y_BrUb2KPoLTmPbzoPuvnNj2Gpyb0zpO');
export const PUB4_QUALRES_URL = GOOGLE_DRIVE_ROOT('1psg5HyhH-XozeYPe5kSwK_TuP5x7fzbj');
export const PUB4_POSTER_URL = 'https://drive.google.com/file/d/1x5wvqRIHb4PnMraK9wRCEqY-HJTnFvrZ/view?usp=drive_link';